import { useState } from "react";
import { Button } from "expano-components";
import { client } from "utils/api";

import { getWeekDays } from "utils/select_options/weekdays_options";
import { getChannelCampaignGroupSalesPeriodType } from "utils/select_options/channel_campaign_group_sales_period_type_options";

import EditSalesPeriodModal from "./EditSalesPeriodModal";

const Item = ({
  channel_id,
  refetch,
  id,
  days_of_week,
  start_time,
  end_time,
  period_type,
}) => {
  const [is_deleting, setDeleting] = useState(false);
  const [is_editing, setEditing] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await client.delete(`/channel_sales_periods/${id}`);
      await refetch();
    } catch (error) {
    } finally {
      setDeleting(false);
    }
  };

  return (
    <tr>
      {is_editing && (
        <EditSalesPeriodModal
          id={id}
          channel_id={channel_id}
          refetch={refetch}
          handleClose={() => setEditing(false)}
          initialValues={{
            period_type,
            start_time,
            end_time,
            days_of_week,
          }}
        />
      )}
      <td>{getChannelCampaignGroupSalesPeriodType(period_type)}</td>
      <td>{start_time}</td>
      <td>{end_time}</td>
      <td>{getWeekDays(days_of_week)}</td>
      <td>
        <Button type="edit" onClick={() => setEditing(true)} />
        <Button
          disabled={is_deleting}
          type="delete-bin"
          onClick={handleDelete}
        />
      </td>
    </tr>
  );
};

export default Item;
